import React from "react";
import DropdownFilter from "../common/DropdownFilter";

const MappingFilters = ({ statusFilter, setStatusFilter, mappingFilter, setMappingFilter }) => {
  const mappingOptions = [
    { value: "All", label: "All" },
    { value: "Mapped", label: "Mapped" },
    { value: "Unmapped", label: "Unmapped" },
  ];

  const statusOptions = [
    { value: "All", label: "All" },
    { value: "Required", label: "Required" },
    { value: "Optional", label: "Optional" },
  ];

  return (
    <div className="filter-group-dropdown">
      <DropdownFilter
        label="Mapping"
        value={mappingFilter}
        options={mappingOptions}
        onChange={setMappingFilter}
      />
      <DropdownFilter
        label="Show"
        value={statusFilter}
        options={statusOptions}
        onChange={setStatusFilter}
      />
    </div>
  );
};

export default MappingFilters;
